import Button from "../Dealers/Button";

const ReleaseLineModal = ({
  item,
  onConfirm,
  onClose,
  mode,
  activeType,
  releaseLoader,
}) => {
  //   console.log(item);

  const currentPriority = item?.priority || "Normal";

  const newPriority = currentPriority === "Normal" ? "Urgent" : "Normal";

  const handleConfirm = () => {
    if (releaseLoader) return;

    // Send complete item + new priority
    onConfirm(item, newPriority);
  };

  const isDark = mode;

  const colors = {
    overlay: "rgba(0, 0, 0, 0.55)",
    background: isDark ? "#232529" : "#FFFFFF",
    text: isDark ? "#F9FAFB" : "#111827",
    muted: isDark ? "#9CA3AF" : "#6B7280",
    border: isDark ? "#36393F" : "#E5E7EB",
    boxBg: isDark ? "#1B1D21" : "#F8F9FC",
    urgentBg: isDark ? "#3A2020" : "#FEF2F2",
    urgentText: "#EF4444",
    normalBg: isDark ? "#1E3328" : "#ECFDF5",
    normalText: "#16A34A",
  };

  return (
    <div
      onClick={releaseLoader ? undefined : onClose}
      style={{
        position: "fixed",
        inset: 0,
        backgroundColor: colors.overlay,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 10000,
        padding: 20,
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          width: "100%",
          maxWidth: 430,
          backgroundColor: colors.background,
          color: colors.text,
          borderRadius: 18,
          border: `1px solid ${colors.border}`,
          padding: 28,
          boxShadow: "0 20px 50px rgba(0, 0, 0, 0.2)",
        }}
      >
        {/* Header */}
        <div
          style={{
            textAlign: "center",
            marginBottom: 24,
          }}
        >
          <div
            style={{
              width: 48,
              height: 48,
              borderRadius: "50%",
              backgroundColor:
                newPriority === "Urgent" ? colors.urgentBg : colors.normalBg,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 12px",
              fontSize: 22,
              fontWeight: 600,
              color:
                newPriority === "Urgent"
                  ? colors.urgentText
                  : colors.normalText,
            }}
          >
            {newPriority === "Urgent" ? "!" : "✓"}
          </div>

          <h3
            style={{
              margin: 0,
              fontSize: 18,
              fontWeight: 600,
              color: colors.text,
            }}
          >
            Release Production Line from Voucher {item?.orderId} Item No{" "}
            <span style={{ color: "#4164E3" }}>
              {item?.itemCode || item?.ItemNo}
            </span>
          </h3>

          <p
            style={{
              margin: "7px 0 0",
              fontSize: 13,
              color: colors.muted,
            }}
          >
            Are you sure you want to release this production line{" "}
            <span style={{ color: "#4164E3", fontWeight: "600" }}>
              {" "}
              {item?.machine || item?.productionLine}
            </span>{" "}
            ?{" "}
          </p>
        </div>

        {/* Actions */}
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 10,
          }}
        >
          <Button
            buttonClick={onClose}
            buttonText="No"
            buttonBgColor={"#000000"}
            buttonTextColor="#FFFFFF"
            disabled={releaseLoader}
          />

          <Button
            loading={releaseLoader}
            buttonClick={handleConfirm}
            buttonText="Yes"
            buttonBgColor="#4164E3"
            buttonTextColor="#FFFFFF"
          />
        </div>
      </div>
    </div>
  );
};

export default ReleaseLineModal;
